import { render, staticRenderFns } from "./MarginAllocation.vue?vue&type=template&id=5be413af&scoped=true&"
import script from "./MarginAllocation.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MarginAllocation.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MarginAllocation.vue?vue&type=style&index=0&id=5be413af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be413af",
  null
  
)

export default component.exports